import React from 'react';
import CustomerDescription from './CustomerDescription';
import { BtnPrimary } from '../../../share/buttons/Btn';
import Card from '../../../share/cards/Card';
import snapp from '../../../../Assets/Image/png/snapp.png';
import divar from '../../../../Assets/Image/png/divar.png';
import fidibo from '../../../../Assets/Image/png/ficimo.png';
import filimo from '../../../../Assets/Image/png/filimo.png';
import { NavLink } from 'react-router-dom';
import { HashLink, NavHashLink } from 'react-router-hash-link';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

// import required modules
import { Navigation } from 'swiper';

// Import Swiper styles
import 'swiper/css';

const customersImages = [snapp, divar, fidibo, filimo];

function Customers() {
	return (
		<div className='container'>
			<div className=' flex flex-col mb-16	'>
				<h2 className='text-md primary-dark items-center flex justify-center mb-8 font-bold'>
					حرفه‌ای‌ها درباره ما چه می‌گویند؟
				</h2>
				<div className='flex justify-between home__customer--card'>
					{customersImages.map((img, key) => {
						return (
							<Card
								key={key}
								className='w-[21rem] h-[17.3rem] flex items-center justify-center'
							>
								<img src={img} />
							</Card>
						);
					})}
				</div>
			</div>
			<CustomerDescription />

			<div className=' justify-center flex items-center'>
				<HashLink key='bootcamps' to='/bootcamp#top'>
					<BtnPrimary
						className='py-7 px-10 rounded-full'
						text='بوت‌کمپ مورد نظر خود را پیدا کنید!'
						type='button'
					/>
				</HashLink>
			</div>
		</div>
	);
}

export default Customers;
